import { useEffect, useState, useRef } from 'react';
import { containsSpecialChars } from '../../util/DataUtil';

export default function TemplateItems({
  children,
  setItemCount,
  itemCount,
  contentType,
}) {
  const [isScrolled2, setIsScrolled2] = useState(false);
  const [isScrolled2half, setIsScrolled2half] = useState(false);
  const [isScrolled3, setIsScrolled3] = useState(false);
  const [isScrolled4, setIsScrolled4] = useState(false);
  const [isScrolled4half, setIsScrolled4half] = useState(false);
  const [isScrolled5, setIsScrolled5] = useState(false);
  const [isScrolled6, setIsScrolled6] = useState(false);
  const [isScrolled10, setIsScrolled10] = useState(false);
  const [isScrolled11, setIsScrolled11] = useState(false);
  const [isScrolled12, setIsScrolled12] = useState(false);
  const [isScrolled15, setIsScrolled15] = useState(false);
  const [isScrolled17, setIsScrolled17] = useState(false);

  const [hasCaseStudyParent, setHasCaseStudyParent] = useState('');
  const rootRef = useRef(null);
  if (children?.field_display_block[0]?.value != 1) {
    return '';
  }

  useEffect(() => {
    const checkCaseStudyParent = (element) => {
      while (element) {
        if (
          element.classList &&
          element.classList.contains('case_study_dynamic')
        ) {
          return true;
        }
        element = element.parentElement;
      }
      return false;
    };

    setHasCaseStudyParent(checkCaseStudyParent(rootRef.current));

    setItemCount(
      children?.field_paragraph_title_subtitle?.title_subtitle_paragraph_type
        ?.length || 0
    );

    let scrollTimeout;

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const scrollPercentage =
        (scrollPosition / (documentHeight - windowHeight)) * 100;
      if (window.innerWidth < 417) {
        setIsScrolled2(scrollPercentage >= 2);
        setIsScrolled4(scrollPercentage >= 4);
      } else if (window.innerWidth >= 417 && window.innerWidth < 576) {
        setIsScrolled2half(scrollPercentage >= 2.5);
        setIsScrolled4half(scrollPercentage >= 4.5);
      } else if (window.innerWidth >= 576 && window.innerWidth < 1025) {
        setIsScrolled3(scrollPercentage >= 3);
        setIsScrolled5(scrollPercentage >= 5);
      } else if (window.innerWidth >= 1025 && window.innerWidth < 1220) {
        setIsScrolled5(scrollPercentage >= 5);
        setIsScrolled10(scrollPercentage >= 10);
      } else if (window.innerWidth >= 1220 && window.innerWidth < 1440) {
        setIsScrolled6(scrollPercentage >= 6);
        setIsScrolled12(scrollPercentage >= 12);
      } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        setIsScrolled10(scrollPercentage >= 10);
        setIsScrolled15(scrollPercentage >= 15);
      } else {
        setIsScrolled11(scrollPercentage >= 11);
        setIsScrolled17(scrollPercentage >= 17);
      }
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(() => {
        // Additional logic if needed when scroll event finishes
      }, 300);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(scrollTimeout);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [setItemCount, children]);

  return contentType == 'content_template' ? (
    <div className="inner-container">
      <div
        ref={rootRef}
        className={
          itemCount
            ? `template-items template-items-item-${itemCount}`
            : 'template-items'
        }
      >
        <span className={'sub'}>{children?.field_title_field[0]?.value}</span>
        <div className={'items'}>
          {itemCount > 1 &&
            renderItems(
              children?.field_paragraph_title_subtitle
                ?.title_subtitle_paragraph_type,
              isScrolled11,
              isScrolled17,
              isScrolled5,
              isScrolled3,
              isScrolled6,
              isScrolled2,
              isScrolled2half,
              isScrolled4,
              isScrolled4half,
              isScrolled10,
              isScrolled12,
              isScrolled15,
              hasCaseStudyParent
            )}
          {itemCount === 1 &&
            renderOneItem(
              children?.field_paragraph_title_subtitle
                ?.title_subtitle_paragraph_type
            )}
        </div>
      </div>
    </div>
  ) : (
    <div
      ref={rootRef}
      className={
        itemCount
          ? `template-items template-items-item-${itemCount}`
          : 'template-items'
      }
    >
      <span className={'sub'}>{children?.field_title_field[0]?.value}</span>
      <div className={'items'}>
        {itemCount > 1 &&
          renderItems(
            children?.field_paragraph_title_subtitle
              ?.title_subtitle_paragraph_type,
            isScrolled11,
            isScrolled17,
            isScrolled5,
            isScrolled3,
            isScrolled6,
            isScrolled2,
            isScrolled2half,
            isScrolled4,
            isScrolled4half,
            isScrolled10,
            isScrolled12,
            isScrolled15,
            hasCaseStudyParent
          )}
        {itemCount === 1 &&
          renderOneItem(
            children?.field_paragraph_title_subtitle
              ?.title_subtitle_paragraph_type
          )}
      </div>
    </div>
  );
}

const renderItems = (
  items,
  isScrolled11,
  isScrolled17,
  isScrolled5,
  isScrolled3,
  isScrolled6,
  isScrolled2,
  isScrolled2half,
  isScrolled4,
  isScrolled4half,
  isScrolled10,
  isScrolled12,
  isScrolled15,
  hasCaseStudyParent
) => {
  let render = [];
  let colors;
  let color;
  if (items.length === 3) {
    if (window.innerWidth < 417) {
      colors = ['secondary-blue', 'grey', 'light-grey'];
      if (isScrolled2 && !isScrolled4) {
        colors = ['grey', 'secondary-blue', 'light-grey'];
      } else if (isScrolled4) {
        colors = ['light-grey', 'grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 417 && window.innerWidth < 576) {
      colors = ['secondary-blue', 'grey', 'light-grey'];
      if (isScrolled2half && !isScrolled4half) {
        colors = ['grey', 'secondary-blue', 'light-grey'];
      } else if (isScrolled4half) {
        colors = ['light-grey', 'grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 576 && window.innerWidth < 1025) {
      colors = ['secondary-blue', 'grey', 'light-grey'];
      if (isScrolled3 && !isScrolled5) {
        colors = ['grey', 'secondary-blue', 'light-grey'];
      } else if (isScrolled5) {
        colors = ['light-grey', 'grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 1025 && window.innerWidth < 1220) {
      colors = ['secondary-blue', 'grey', 'light-grey'];
      if (isScrolled5 && !isScrolled10) {
        colors = ['grey', 'secondary-blue', 'light-grey'];
      } else if (isScrolled10) {
        colors = ['light-grey', 'grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 1220 && window.innerWidth < 1440) {
      colors = ['secondary-blue', 'grey', 'light-grey'];
      if (isScrolled6 && !isScrolled12) {
        colors = ['grey', 'secondary-blue', 'light-grey'];
      } else if (isScrolled12) {
        colors = ['light-grey', 'grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
      colors = ['secondary-blue', 'grey', 'light-grey'];
      if (isScrolled10 && !isScrolled15) {
        colors = ['grey', 'secondary-blue', 'light-grey'];
      } else if (isScrolled15) {
        colors = ['light-grey', 'grey', 'secondary-blue'];
      }
    } else {
      colors = ['secondary-blue', 'grey', 'light-grey'];
      if (isScrolled11 && !isScrolled17) {
        colors = ['grey', 'secondary-blue', 'light-grey'];
      } else if (isScrolled17) {
        colors = ['light-grey', 'grey', 'secondary-blue'];
      }
    }
  } else if (items.length === 2) {
    if (window.innerWidth < 417) {
      colors = ['secondary-blue', 'grey'];
      if (isScrolled4) {
        colors = ['grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 417 && window.innerWidth < 576) {
      colors = ['secondary-blue', 'grey'];
      if (isScrolled4half) {
        colors = ['grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 576 && window.innerWidth < 1025) {
      colors = ['secondary-blue', 'grey'];
      if (isScrolled5) {
        colors = ['grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 1025 && window.innerWidth < 1220) {
      colors = ['secondary-blue', 'grey'];
      if (isScrolled10) {
        colors = ['grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 1220 && window.innerWidth < 1440) {
      colors = ['secondary-blue', 'grey'];
      if (isScrolled12) {
        colors = ['grey', 'secondary-blue'];
      }
    } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
      colors = ['secondary-blue', 'grey'];
      if (isScrolled15) {
        colors = ['grey', 'secondary-blue'];
      }
    } else {
      colors = ['secondary-blue', 'grey'];
      if (isScrolled17) {
        colors = ['grey', 'secondary-blue'];
      }
    }
  }

  items.forEach((item, index) => {
    if (index == 0) {
      color = 'secondary-blue';
    }
    if (index == 1) {
      color = 'grey';
    }
    if (index == 2) {
      color = 'light-grey';
    }
    let pTitle = item?.field_paragraph_title[0]?.value;

    let slicedChar = item?.field_paragraph_title[0]?.value.slice(-1);
    if (containsSpecialChars(slicedChar)) {
      if (
        item?.field_paragraph_title[0]?.value.endsWith(slicedChar) &&
        slicedChar !== '%'
      ) {
        pTitle = item?.field_paragraph_title[0]?.value.replaceAll(
          slicedChar,
          ''
        );
      }
    }
    render.push(
      <div
        key={index}
        className={`item ${hasCaseStudyParent ? colors[index] : item?.field_paragraph_background_color[0]?.value ? item?.field_paragraph_background_color[0]?.value : color}`}
      >
        <div className={'top'}>
          <span className="top-title">{pTitle}</span>
          {containsSpecialChars(slicedChar) && slicedChar !== '%' && (
            <span className="top-sup">{slicedChar}</span>
          )}
        </div>
        <span className={'bottom'}>
          {item?.field_paragraph_subtitle[0]?.value}
        </span>
      </div>
    );
  });

  return render;
};

const renderOneItem = (items) => {
  let pTitle = items[0].field_paragraph_title[0]?.value;

  let slicedChar = items[0].field_paragraph_title[0]?.value.slice(-1);
  if (containsSpecialChars(slicedChar)) {
    if (
      items[0]?.field_paragraph_title[0]?.value.endsWith(slicedChar) &&
      slicedChar !== '%'
    ) {
      pTitle = items[0]?.field_paragraph_title[0]?.value.replaceAll(
        slicedChar,
        ''
      );
    }
  }
  return (
    <div
      className={`single-item ${items[0]?.field_paragraph_background_color[0]?.value ? items[0]?.field_paragraph_background_color[0]?.value : 'secondary-blue'}`}
    >
      <img alt="border" src="/images/item-border.svg" />
      <div className={'top'}>
        <span className="top-title">{pTitle}</span>
        {containsSpecialChars(slicedChar) && slicedChar !== '%' && (
          <span className="top-sup">{slicedChar}</span>
        )}
      </div>
      <span className={'bottom'}>
        {items[0]?.field_paragraph_subtitle[0]?.value}
      </span>
    </div>
  );
};
